import Swiper from 'swiper';
import 'swiper/css';

const selectors = {
  carouselWrapper: '[data-blog-carousel]',
};

class BlogCarousel extends HTMLElement {
  constructor() {
    super();

    document.addEventListener('DOMContentLoaded', () => {
      this.carouselWrappers = this.querySelectorAll(selectors.carouselWrapper);

      this.breakpoint = window.matchMedia('(max-width:767px)');

      this.render();
    });
  }

  render() {
    // Init the carousel on load.
    this.initCarousels();

    // Subsequently, on resize, we need to check if we need a Swiper object checking the break point.
    // If not, it will get destroyed.
    this.registerEventListeners();
  }

  initCarousels() {
    if (this.breakpoint.matches === false) {
      this.carousel = new Swiper(selectors.carouselWrapper, {
        freeMode: true,
        slidesPerView: 3,
        spaceBetween: 34,
      });
    } else {
      this.carousel = new Swiper(selectors.carouselWrapper, {
        freeMode: true,
        slidesPerView: 'auto',
        spaceBetween: 20,
        watchOverflow: true,
      });
    }
  }

  registerEventListeners() {
    window.addEventListener('resize', () => {
      this.initCarousels();
    });
  }
}

customElements.define('blog-carousel', BlogCarousel);
